export default function Footer() {
  return (
    <footer className="text-white" style={{ background: 'linear-gradient(135deg, #0a1a4a 0%, #1A3A8F 100%)' }}>
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-12 gap-12">
          {/* Left Column - Brand */}
          <div className="md:col-span-5">
            <div className="mb-6">
              <img
                src="https://static.readdy.ai/image/5da477fdae7b1d111ee386eccbf37db2/5fafdbd9edd70d12c9a9e107c1c2ce01.png"
                alt="Manaus Digital"
                className="h-16 w-auto"
              />
            </div>
            <p className="text-blue-100 leading-relaxed mb-8 max-w-sm">
              Somos uma iniciativa criada para valorizar e dar voz ao ecossistema de inovação, empreendedorismo e tecnologia da capital da Amazônia.
            </p>
            <div className="flex gap-4">
              <a
                href="https://instagram.com/manausdigital.br"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110 cursor-pointer border-2"
                style={{ borderColor: 'rgba(0,191,255,0.4)' }}
                onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.borderColor = '#00BFFF'; (e.currentTarget as HTMLAnchorElement).style.color = '#00BFFF'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(0,191,255,0.4)'; (e.currentTarget as HTMLAnchorElement).style.color = 'white'; }}
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://www.youtube.com/@manausdigitalpodcast/videos"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110 cursor-pointer border-2"
                style={{ borderColor: 'rgba(0,191,255,0.4)' }}
                onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.borderColor = '#ff4444'; (e.currentTarget as HTMLAnchorElement).style.color = '#ff4444'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(0,191,255,0.4)'; (e.currentTarget as HTMLAnchorElement).style.color = 'white'; }}
              >
                <i className="ri-youtube-line text-xl"></i>
              </a>
              <a
                href="https://open.spotify.com/show/4971KjDEiJP4D0htdMG78u"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110 cursor-pointer border-2"
                style={{ borderColor: 'rgba(0,191,255,0.4)' }}
                onMouseEnter={e => { (e.currentTarget as HTMLAnchorElement).style.borderColor = '#1db954'; (e.currentTarget as HTMLAnchorElement).style.color = '#1db954'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLAnchorElement).style.borderColor = 'rgba(0,191,255,0.4)'; (e.currentTarget as HTMLAnchorElement).style.color = 'white'; }}
              >
                <i className="ri-spotify-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Center Column - Contact */}
          <div className="md:col-span-4">
            <h3 className="text-xs font-bold uppercase tracking-widest mb-6" style={{ color: '#00BFFF' }}>Contato</h3>
            <div className="space-y-4">
              <div>
                <p className="text-blue-100 mb-1">Manaus - AM</p>
                <p className="text-blue-200 text-sm">Amazônia, Brasil</p>
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase tracking-widest mb-2" style={{ color: '#00BFFF' }}>Instagram</h4>
                <a
                  href="https://instagram.com/manausdigital.br"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-100 transition-colors cursor-pointer hover:text-white"
                >
                  @manausdigital.br
                </a>
              </div>
              <div>
                <h4 className="text-xs font-bold uppercase tracking-widest mb-2" style={{ color: '#00BFFF' }}>E-mail</h4>
                <a href="mailto:contato@manausdigital.com" className="text-blue-100 transition-colors cursor-pointer hover:text-white">
                  contato@manausdigital.com
                </a>
              </div>
            </div>
          </div>

          {/* Right Column - Stats & Platforms */}
          <div className="md:col-span-3">

            {/* Stat */}
            <div className="mb-2">
              <p className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#00BFFF' }}>Audiência / Alcance</p>
            </div>
            <div className="mb-6 p-4 rounded-xl border" style={{ borderColor: 'rgba(0,191,255,0.2)', background: 'rgba(0,191,255,0.05)' }}>
              <p className="text-3xl font-extrabold leading-none" style={{ color: '#00BFFF' }}>+100 mil</p>
              <p className="text-blue-100 text-sm mt-1">downloads &amp; plays</p>
            </div>

            {/* Platform logos */}
            <div className="grid grid-cols-3 gap-2">
              {/* YouTube */}
              <a
                href="https://www.youtube.com/@manausdigitalpodcast/videos"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center gap-1.5 py-3 rounded-lg border transition-all hover:scale-105 cursor-pointer"
                style={{ borderColor: 'rgba(255,68,68,0.3)', background: 'rgba(255,68,68,0.08)' }}
              >
                <i className="ri-youtube-fill text-2xl leading-none" style={{ color: '#ff4444' }}></i>
                <span className="text-xs text-blue-100 leading-none">YouTube</span>
              </a>

              {/* Spotify */}
              <a
                href="https://open.spotify.com/show/4971KjDEiJP4D0htdMG78u"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center gap-1.5 py-3 rounded-lg border transition-all hover:scale-105 cursor-pointer"
                style={{ borderColor: 'rgba(29,185,84,0.3)', background: 'rgba(29,185,84,0.08)' }}
              >
                <i className="ri-spotify-fill text-2xl leading-none" style={{ color: '#1db954' }}></i>
                <span className="text-xs text-blue-100 leading-none">Spotify</span>
              </a>

              {/* Apple Podcasts */}
              <a
                href="https://podcasts.apple.com"
                target="_blank"
                rel="noopener noreferrer"
                className="flex flex-col items-center justify-center gap-1.5 py-3 rounded-lg border transition-all hover:scale-105 cursor-pointer"
                style={{ borderColor: 'rgba(188,75,255,0.3)', background: 'rgba(188,75,255,0.08)' }}
              >
                <i className="ri-apple-fill text-2xl leading-none" style={{ color: '#bc4bff' }}></i>
                <span className="text-xs text-blue-100 leading-none">Apple Pod.</span>
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t" style={{ borderColor: 'rgba(0,191,255,0.15)' }}>
        <div className="max-w-7xl mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-blue-200 text-sm">
              © 2026 Manaus Digital. Todos os direitos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-blue-200 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Política de Privacidade
              </a>
              <span style={{ color: 'rgba(0,191,255,0.3)' }}>•</span>
              <a href="#" className="text-blue-200 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                Termos de Uso
              </a>
              <span style={{ color: 'rgba(0,191,255,0.3)' }}>•</span>
              <a href="#" className="text-blue-200 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                FAQ
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
